import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {connect} from 'react-redux';

import ToastAx               from 'app/actions/toast';
import Checkbox              from 'app/components/common/checkbox';
import Icon                  from 'app/components/common/icon';
import Modal                 from 'app/components/common/modal';
import NumberInput           from 'app/components/common/number-input';
import RteEditor             from 'app/components/common/rich-text/editor';
import StandardInput         from 'app/components/common/standard-input';
import StandardSelect        from 'app/components/common/standard-select';
import MultiEmpSelect        from 'app/components/company-admin/common/multi-emp-select';
import RubricInput           from 'app/components/company-admin/grant-system/rubric/input';
import GrantSysDuck          from 'app/ducks/company-admin/grant-system';
import helpers               from 'app/helpers/grant-system';
import rubricHelpers         from 'app/helpers/rubrics';
import prompts               from 'app/prompts';
import EllipsisMenu from '../../common/ellipsis-menu';

const {TaskTypes, FieldPresenceTypes} = helpers;

const Tabs = {
  TYPE: 'type',
  SETTINGS: 'settings',
  REVIEWERS: 'reviewers',
  AUTOMATIONS: 'automations',
  DEBUG: 'debug',
};

const taskToState = (task) => {
  const obj = _.pick(task, ['title', 'description', 'type', 'rubric', 'notificationTemplate', 'remarksField', 'fileField', 'autoAssign', 'assCount', 'assVisInternalContent', 'assVisBudget', 'isAutomatic', 'employeeIds']);
  return obj;
};

const fieldPresenceOpts = [
  // {label: 'Off',      value: FieldPresenceTypes.OFF},
  {label: 'Optional', value: FieldPresenceTypes.OPTIONAL},
  {label: 'Required', value: FieldPresenceTypes.REQUIRED},
];

const noop = () => {};



class ModalGrantTaskEdit extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      ...taskToState(props.task || {}),
      rubricValid: true,
      rubricDone: true,
      activeTab: (props.task || props.assigneesOnly) ? Tabs.REVIEWERS : Tabs.TYPE,
      tabCompleteMap: {},
      savePending: false,
      saveError: false,
    };

    this.onChangeTitle = this.onChangeTitle.bind(this);
    this.onChangeDesc = this.onChangeDesc.bind(this);
    this.onChangeRemarksField = this.onChangeRemarksField.bind(this);
    this.onChangeFileField = this.onChangeFileField.bind(this);
    this.onChangeRemarksFieldOn = this.onChangeRemarksFieldOn.bind(this);
    // this.onChangeRemarksFieldRequired = this.onChangeRemarksFieldRequired.bind(this);
    this.onChangeFileFieldOn = this.onChangeFileFieldOn.bind(this);
    // this.onChangeFileFieldRequired = this.onChangeFileFieldRequired.bind(this);
    this.onChangeRubricOn = this.onChangeRubricOn.bind(this);
    this.onChangeAutoAssign = this.onChangeAutoAssign.bind(this);
    this.onChangeAssCount = this.onChangeAssCount.bind(this);
    this.onChangeAssVisBudget = this.onChangeAssVisBudget.bind(this);
    this.onChangeAssVisInternalContent = this.onChangeAssVisInternalContent.bind(this);
    this.onChangeEmployees = this.onChangeEmployees.bind(this);
    this.onChangeRubric = this.onChangeRubric.bind(this);

    this.onClose = this.onClose.bind(this);
    this.onClickCreate = this.onClickCreate.bind(this);
    this.onClickUpdate = this.onClickUpdate.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
  }

  get hasApps() {
    return (this.props.appCounts[this.props.workflow?.id] || 0) > 0;
  }

  get isUpdate() {
    return !!this.props.task;
  }
  get isCreate() {
    return !this.isUpdate;
  }
  get stageTypeObj() {
    return helpers.stageTypeObj(this.props.stage);
  }
  get taskTypeObj() {
    return helpers.taskTypeObj(this.state.type);
  }
  get availableTaskTypeObjs() {
    const {type} = this.state;
    const stageTypes = this.stageTypeObj.addableTaskTypes;
    if (this.isCreate) return stageTypes;
    const isReviewType = helpers.isReviewType(type);
    return isReviewType ? helpers.reviewTaskTypes : [type];
  }
  get isTemplate() {
    return !this.props.workflow?.grantProgramId;
  }

  get canDelete() {
    if (this.isCreate) return false;
    if (this.taskTypeObj.key === TaskTypes.FINAL) return false;
    return true;
  }

  get saveAttrs() {
    const taskTypeObj = this.taskTypeObj;
    const obj = _.pick(this.state, ['type', 'title', 'description', 'autoAssign', 'employeeIds', 'assVisInternalContent', 'assVisBudget']);
    if (taskTypeObj) {
      obj.remarksField = taskTypeObj.allowRemarks   ? this.state.remarksField : FieldPresenceTypes.OFF;
      obj.fileField    = taskTypeObj.allowFile      ? this.state.fileField    : FieldPresenceTypes.OFF;
      obj.rubric       = taskTypeObj.allowRubric    ? this.state.rubric       : null;
      obj.assCount     = taskTypeObj.allowAssCount  ? this.state.assCount     : 1;
      obj.isAutomatic  = taskTypeObj.allowAutomatic ? this.state.isAutomatic  : false;
      Object.assign(obj, (taskTypeObj.forcedAttrs || {}));
      if (taskTypeObj.key === TaskTypes.NOTIFY) obj.notificationTemplate = this.state.notificationTemplate;
    }
    ['title', 'description'].forEach((attr) => {
      obj[attr] = (obj[attr] || '').trim();
    });
    if (this.isCreate) {
      obj.grantStageId = this.props.stage.id;
    }
    if (this.props.assigneesOnly) {
      return _.pick(obj, ['autoAssign', 'employeeIds', 'assVisInternalContent', 'assVisBudget', 'assCount']);
    }
    return obj;
  }

  get validity() {
    const attrs = this.saveAttrs;
    const hasValidType = (() => {
      if (!attrs.type) return false;
      const typeObj = helpers.taskTypeObj(attrs.type);
      if (typeObj.comingSoon) return false;
      return true;
    })();
    const hasValidSettings = (() => {
      if (!attrs.title) return false;
      if (this.state.rubric && !this.state.rubricValid) return false;
      if (!Object.values(FieldPresenceTypes).includes(this.state.remarksField)) return false;
      if (!Object.values(FieldPresenceTypes).includes(this.state.fileField)) return false;
      return true;
    })();
    const hasValidReviewers = (() => {
      // TODO: implement
      return true;
    })();
    const hasValidAutomations = (() => {
      // TODO: implement
      return true;
    })();
    const canSave = this.props.assigneesOnly
      ? hasValidReviewers
      : (hasValidType && hasValidSettings && hasValidReviewers && hasValidAutomations);

    return {hasValidType, hasValidSettings, hasValidReviewers, hasValidAutomations, canSave};
  }

  onClickType(typeObj) {
    this.setState((prevState) => {
      if (prevState.type === typeObj.key) return prevState;
      const hasCompletedSettings = !!prevState.tabCompleteMap[Tabs.SETTINGS];
      const shouldDefault = this.isCreate && !hasCompletedSettings;
      return {
        type: typeObj.key,
        ...(shouldDefault ? typeObj.getDefaultAttrs() : {}),
        ...typeObj.forcedAttrs,
      };
    });
  }
  onChangeTitle(event, title) {
    this.setState({title});
  }
  onChangeDesc(md) {
    this.setState({description: md});
  }
  onChangeRemarksField(remarksField) {
    this.setState({remarksField});
  }
  onChangeFileField(fileField) {
    this.setState({fileField});
  }
  onChangeRemarksFieldOn(event) {
    const isOn = event.target.checked;
    const remarksField = isOn ? FieldPresenceTypes.OPTIONAL : FieldPresenceTypes.OFF;
    this.setState({remarksField});
  }
  // onChangeRemarksFieldRequired(event) {
  //   const isOn = event.target.checked;
  //   const remarksField = isOn ? FieldPresenceTypes.REQUIRED : FieldPresenceTypes.OPTIONAL;
  //   this.setState({remarksField});
  // }
  onChangeFileFieldOn(event) {
    const isOn = event.target.checked;
    const fileField = isOn ? FieldPresenceTypes.OPTIONAL : FieldPresenceTypes.OFF;
    this.setState({fileField});
  }
  // onChangeFileFieldRequired(event) {
  //   const isOn = event.target.checked;
  //   const fileField = isOn ? FieldPresenceTypes.REQUIRED : FieldPresenceTypes.OPTIONAL;
  //   this.setState({fileField});
  // }

  onChangeRubricOn(event) {
    const isOn = event.target.checked;
    const typeObj = helpers.taskTypeObjs[this.state.type];
    const rubric = (() => {
      if (!isOn) return null;
      return typeObj?.getDefaultAttrs()?.rubric || rubricHelpers.makeRubric();
    })();
    const newState = {rubric};
    if (!rubric) {
      newState.rubricValid = true;
      newState.rubricDone = true;
    }
    this.setState(newState);
  }
  onChangeRubric(isValid, isDone, saveAttrs) {
    const didChangeToZero = !!this.state.rubric?.crits?.length && !saveAttrs?.crits?.length;
    const rubric = didChangeToZero ? null : saveAttrs;
    const rubricValid = !rubric || !!isValid;
    this.setState({rubric, rubricValid, rubricDone: isDone});
  }

  onChangeAutoAssign(event) {
    const autoAssign = event.target.checked;
    this.setState({autoAssign});
  }
  onChangeAssCount(assCount) {
    this.setState({assCount});
  }
  onChangeEmployees(mesComp) {
    const employeeIds = mesComp.selectedEmployeeIds;
    this.setState({employeeIds});
  }
  onChangeAssVisBudget(event) {
    const assVisBudget = event.target.checked;
    this.setState({assVisBudget});
  }
  onChangeAssVisInternalContent(event) {
    const assVisInternalContent = event.target.checked;
    this.setState({assVisInternalContent});
  }

  onClose() {
    this.props.onClose();
  }

  onClickTab(tabKey, markAsCompleteTab) {
    this.setState((prevState) => {
      const tabCompleteMap = {...prevState.tabCompleteMap};
      if (markAsCompleteTab) {
        tabCompleteMap[markAsCompleteTab] = true;
      }
      return {activeTab: tabKey, tabCompleteMap};
    });
    this.setState({activeTab: tabKey});
  }

  async onClickDelete() {
    const msg = 'Deleting a task while the workflow actively has applications moving through it may cause disruptions.\nThis can not be undone.';
    if (!this.canDelete) return;
    const didConfirm = await prompts.confirm({msg, danger: 'Delete Task', doubleConfirm: true});
    if (didConfirm) {
      await this.props.deleteTask();
      this.props.onClose();
      this.props.toastSuccess('Task deleted.');
    }
  }

  async onClickCreate() {
    const msg = 'Adding a new task while the workflow actively has applications moving through it may cause disruptions.\nPlease proceeed with caution.';
    const didConfirm = await (this.hasApps
      ? prompts.confirm({msg, confirmBtnLabel: 'Create Task'})
      : true
    );
    if (didConfirm) {
      this.save(this.props.createTask, 'Task created.');
    }
  }
  async onClickUpdate() {
    const needsConfirm = !this.props.assigneesOnly && this.hasApps;
    if (needsConfirm) {
      const msg = 'Changing the task configuration while the workflow actively has applications moving through it may cause disruptions.\nPlease proceeed with caution.';
      const didConfirm = await prompts.confirm({msg, confirmBtnLabel: 'Save Changes to Task'});
      if (!didConfirm) return;
    }
    const toastMsg = this.props.assigneesOnly ? 'Assignees updated.' : 'Task updated.';
    this.save(this.props.updateTask, toastMsg);
  }
  async save(saveFn, successMsg) {
    this.setState({savePending: true, saveError: false});
    const afterState = {savePending: false};
    let didSucceed = false;
    try {
      await saveFn(this.saveAttrs);
      didSucceed = true;
    } catch (error) {
      afterState.saveError = true;
      console.error(error);
    }
    this.setState(afterState);
    if (didSucceed) {
      this.props.onClose();
      this.props.toastSuccess(successMsg);
    }
  }

  renderTabs() {
    const {assigneesOnly} = this.props;
    if (assigneesOnly) return null;
    const {activeTab, tabCompleteMap} = this.state;
    const {isCreate, isUpdate} = this;
    const {hasValidSettings, hasValidReviewers, hasValidAutomations, hasValidType} = this.validity;
    const tabs = [];
    const showType = this.availableTaskTypeObjs?.length > 1;
    if (showType) {
      tabs.push({key: Tabs.TYPE,        label: 'Task Type',   IconComp: Icon.ArrowButtonCircleDown, isComplete: !!(tabCompleteMap[Tabs.TYPE]),        isValid: hasValidType});
    }
    tabs.push({  key: Tabs.SETTINGS,    label: 'Settings',    IconComp: Icon.Cog1,                  isComplete: !!(tabCompleteMap[Tabs.SETTINGS]),    isValid: hasValidSettings});
    tabs.push({  key: Tabs.REVIEWERS,   label: 'Assignees',   IconComp: Icon.UserFriends1,          isComplete: !!(tabCompleteMap[Tabs.REVIEWERS]),   isValid: hasValidReviewers});
    tabs.push({  key: Tabs.AUTOMATIONS, label: 'Automations', IconComp: Icon.ForkAdvancement,       isComplete: !!(tabCompleteMap[Tabs.AUTOMATIONS]), isValid: hasValidAutomations});
    // tabs.push({  key: Tabs.DEBUG,       label: 'Debug',       IconComp: Icon.Cog1,                  isComplete: true});
    let hasIncompletePrevStep = false;

    return (
      <div className="wizard-steps">
        {tabs.map((tab) => {
          const {IconComp} = tab;
          const activeClass = (tab.key === activeTab) ? 'active' : '';
          const disabled = (() => {
            if (tab.key === Tabs.AUTOMATIONS) return true;
            if (isUpdate) return false;
            if (tab.key === Tabs.DEBUG) return false;
            return hasIncompletePrevStep;
          })();
          const completeClass = (isCreate && tab.isComplete && tab.isValid) ? 'complete' : '';
          if (!tab.isComplete) hasIncompletePrevStep = true;
          const invalidClass = (isUpdate && !tab.isValid) ? 'invalid' : '';

          return (
            <button key={tab.key} className={`wizard-steps-step ${activeClass} ${completeClass} ${invalidClass}`} disabled={disabled} onClick={this.onClickTab.bind(this, tab.key, null)}>
              <IconComp className="wizard-steps-step-icon" sw1_5 />
              <span className="wizard-steps-step-label">{tab.label}</span>
            </button>
          );
        })}
      </div>
    );
  }

  renderScreenType() {
    const {activeTab, type} = this.state;
    if (activeTab !== Tabs.TYPE) return null;
    // const taskTypes = this.stageTypeObj.addableTaskTypes;
    const taskTypes = this.availableTaskTypeObjs;
    // const canChange = !this.isUpdate;

    return (<>
      <div className="modal-gtedit-screen">
        <div className="modal-gtedit-screen-types">
          {taskTypes.map((taskType) => {
            const typeObj = helpers.taskTypeObj(taskType);
            const {IconComp} = typeObj;
            const isActive = typeObj.key === this.taskTypeObj?.key;
            const disabled = false;//typeObj.comingSoon;
            const activeClass = isActive ? 'active' : '';

            return (
              <button key={typeObj.key} className={`modal-gtedit-screen-types-type ${activeClass}`} disabled={disabled} onClick={this.onClickType.bind(this, typeObj)}>
                <IconComp className="modal-gtedit-screen-types-type-icon" />
                <div className="modal-gtedit-screen-types-type-text">
                  <div className="_fw-bold _fs-16">{typeObj.label}</div>
                  <div className="_clr-mid">{typeObj.description}</div>
                </div>
                {!!typeObj.comingSoon && (
                  <div className="modal-gtedit-screen-types-type-soon">Coming Soon</div>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </>);
  }

  renderScreenSettings() {
    const {activeTab, title, description, fileField, remarksField, rubric} = this.state;
    if (activeTab !== Tabs.SETTINGS) return null;
    const {taskTypeObj} = this;
    const {allowRemarks, allowFile, allowRubric, forcedAttrs, IconComp} = taskTypeObj;
    const canChangeRemarksField = !forcedAttrs.remarksField;
    const canChangeFileField = !forcedAttrs.fileField;

    return (<>
      <div className="modal-gtedit-screen">
        <h2 className="bform-h2">General</h2>

        <label className="bform-h3">Title</label>
        <StandardInput name="title" label="Task title" value={title || ''} onChange={this.onChangeTitle} maxChars={30} />

        <h2 className="bform-h2">Assignee Form</h2>
        <label className="bform-h3">Instructions</label>
        <RteEditor initialMd={description} placeholder="Instructions for the assignee as they complete this task." onChange={this.onChangeDesc} />

        {!!allowRemarks && (<>
          <div className="_flex _justify-between _align-end">
            <label className="bform-h3">Internal Remarks</label>
            <Checkbox checked={remarksField !== FieldPresenceTypes.OFF} onChange={this.onChangeRemarksFieldOn} isToggle offOk disabled={!canChangeRemarksField} />
          </div>
          {(remarksField !== FieldPresenceTypes.OFF) && (
            <div className="_ml-12 _mt-6" style={{width: 200}}>
              <StandardSelect small options={fieldPresenceOpts} value={remarksField} onSelect={this.onChangeRemarksField} noHighlightAny disabled={!canChangeRemarksField} />
            </div>
          )}
        </>)}

        {!!allowFile && (<>
          <div className="_flex _justify-between _align-end">
            <label className="bform-h3">File Upload</label>
            <Checkbox checked={fileField !== FieldPresenceTypes.OFF} onChange={this.onChangeFileFieldOn} isToggle offOk disabled={!canChangeFileField} />
          </div>
          {(fileField !== FieldPresenceTypes.OFF) && (
            <div className="_ml-12 _mt-6" style={{width: 200}}>
              <StandardSelect small options={fieldPresenceOpts} value={fileField} onSelect={this.onChangeFileField} noHighlightAny disabled={!canChangeFileField} />
            </div>
          )}
        </>)}

        {!!allowRubric && (<>
          <div className="_flex _justify-between _align-end">
            <label className="bform-h3">Rubric</label>
            <Checkbox checked={!!rubric} onChange={this.onChangeRubricOn} isToggle offOk />
          </div>
          <p className="_clr-mid">Use a rubric to collect structured answers from assignees. Answers are mapped to numeric values, which can be averaged across multiple assignees and used to drive automated decisions.</p>
          {!!rubric && <RubricInput rubric={rubric} onChange={this.onChangeRubric} />}
        </>)}
      </div>
    </>);
  }

  renderScreenReviewers() {
    const {activeTab, autoAssign, assCount, assVisInternalContent, assVisBudget, employeeIds=[]} = this.state;
    if (activeTab !== Tabs.REVIEWERS) return null;
    const {taskTypeObj} = this;

    return (<>
      <div className="modal-gtedit-screen">
        {!this.isTemplate && (<>
          <h2 className="bform-h2">Assignee Pool</h2>
          <p className="_clr-mid">Employees added to the assignee pool have will have permission to perform this task. When Auto Assign is enabled, employees in the pool will be automatically assigned this task.</p>
          <MultiEmpSelect onChange={this.onChangeEmployees} initialEmployeeIds={employeeIds} />
        </>)}

        <h2 className="bform-h2">Number of Assignees per Application</h2>
        <p className="_clr-mid">The number of assignees that need to complete this task.</p>
        <NumberInput min={1} max={20} onChange={this.onChangeAssCount} value={assCount} disabled={!taskTypeObj.allowAssCount} name="assCount" allowNull={false} label="e.g. 3" />

        <div className="_flex _justify-between _align-end">
          <h2 className="bform-h2">Auto Assign</h2>
          <Checkbox checked={autoAssign} onChange={this.onChangeAutoAssign} isToggle offOk />
        </div>
        <p className="_clr-mid">When enabled, the least recently used employees in the assignee pool will be automatically assigned this task when the application enters the stage.</p>

        <h2 className="bform-h2">Assignee Access</h2>
        <label className="bform-h3">Application Content</label>
        <label className="_flex _align-center _justify-start">
          <Checkbox checked onChange={noop} isToggle offOk disabled />
          <span className="_clr-mid">Assignees can see the contents of the application.</span>
        </label>
        <label className="bform-h3">Review Content</label>
        <label className="_flex _align-center _justify-start">
          <Checkbox checked={assVisInternalContent} onChange={this.onChangeAssVisInternalContent} isToggle offOk disabled={_.isBoolean(taskTypeObj.forcedAttrs.assVisInternalContent)} />
          <span className="_clr-mid">When enabled, assignees can see the full history of the application including other assignees' reviews, comments, etc.</span>
        </label>
        <label className="bform-h3">Program Budget</label>
        <label className="_flex _align-center _justify-start">
          <Checkbox checked={assVisBudget} onChange={this.onChangeAssVisBudget} isToggle offOk disabled={_.isBoolean(taskTypeObj.forcedAttrs.assVisBudget)} />
          <span className="_clr-mid">When enabled, assignees can see the program's budget.</span>
        </label>
      </div>
    </>);
  }

  renderScreenAutomations() {
    const {activeTab} = this.state;
    if (activeTab !== Tabs.AUTOMATIONS) return null;

    return (
      <div className="modal-gtedit-screen">
        Automations
      </div>
    );
  }

  renderScreenDebug() {
    const {activeTab} = this.state;
    if (activeTab !== Tabs.DEBUG) return null;

    const {state, stageTypeObj, taskTypeObj, isUpdate, isCreate, saveAttrs} = this;

    return (
      <div className="modal-gtedit-screen">
        <h2 className="bform-h2">State</h2>
        <pre>{JSON.stringify({isCreate, isUpdate, saveAttrs}, null, 4)}</pre>
      </div>
    );
  }

  renderActions() {
    const {isCreate} = this;
    const {hasValidSettings, hasValidReviewers, hasValidType, canSave} = this.validity;
    const {activeTab, rubricDone, savePending} = this.state;
    if (isCreate && activeTab === Tabs.TYPE) {
      return <button className="btn blue" onClick={this.onClickTab.bind(this, Tabs.SETTINGS, activeTab)} disabled={!hasValidType}>Next</button>;
    }
    if (isCreate && activeTab === Tabs.SETTINGS) {
      return <button className="btn blue" onClick={this.onClickTab.bind(this, Tabs.REVIEWERS, activeTab)} disabled={!hasValidSettings || !rubricDone}>Next</button>;
    }
    // if (isCreate && activeTab === Tabs.REVIEWERS) {
    //   return <button className="btn blue" onClick={this.onClickTab.bind(this, Tabs.AUTOMATIONS, activeTab)} disabled={!hasValidReviewers}>Next</button>;
    // }

    const disabled = !canSave || savePending;
    const label = this.isUpdate
      ? (savePending ? 'Saving...'   : 'Save Changes')
      : (savePending ? 'Creating...' : 'Create Task');
    const onClick = this.isUpdate ? this.onClickUpdate : this.onClickCreate;
    return <button className="btn blue" onClick={onClick} disabled={disabled}>{label}</button>;
  }

  render() {
    const {isUpdate} = this;
    const title = isUpdate ? `Edit: ${this.props.task.title}` : 'Add Task';
    const {stage} = this.props;

    return (
      <Modal className="bform modal-gtedit" onClose={this.onClose}>
        <div className="_flex _justify-start _align-center">
          <h1 className="bform-h1">{title}</h1>
          {!this.isUpdate && <span>to</span>}
          <div className="gstage-badge" style={{backgroundColor: stage.color}}>{stage.title}</div>
          <div className="_flex-1" />
          {this.canDelete && (
            <EllipsisMenu>
              <button onClick={this.onClickDelete}><Icon.Bin /> Delete Task</button>
            </EllipsisMenu>
          )}
        </div>

        {this.renderTabs()}
        {this.renderScreenType()}
        {this.renderScreenSettings()}
        {this.renderScreenReviewers()}
        {this.renderScreenAutomations()}
        {this.renderScreenDebug()}

        <div className="bform-actions">
          <div className="bform-actions-right">
            {this.renderActions()}
          </div>
        </div>
      </Modal>
    );
  }

}

ModalGrantTaskEdit.propTypes = {
  onClose: PropTypes.func.isRequired,
  workflow: PropTypes.object.isRequired,
  stage: PropTypes.object.isRequired,
  task: PropTypes.object,
  assigneesOnly: PropTypes.bool,
};

ModalGrantTaskEdit.defaultProps = {
  task: null,
  assigneesOnly: false,
};

const stateToProps = (state) => ({
  appCounts: GrantSysDuck.Slx.appCounts(state),
});
const dispatchToProps = (dispatch, ownProps) => ({
  updateTask: (attrs) => dispatch(GrantSysDuck.Ax.tasksUpdate(ownProps.workflow?.id, ownProps.task?.id, attrs)),
  createTask: (attrs) => dispatch(GrantSysDuck.Ax.tasksCreate(ownProps.workflow?.id, attrs)),
  deleteTask:      () => dispatch(GrantSysDuck.Ax.tasksDelete(ownProps.workflow?.id, ownProps.task?.id)),
  toastSuccess: (msg) => dispatch(ToastAx.success(msg)),
});

export default connect(stateToProps, dispatchToProps)(ModalGrantTaskEdit);
